import React from 'react';
// import swiper react components
import {Swiper, SwiperSlide} from 'swiper/react';
// import swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../slider.css';
// import required modules
import {Pagination, Navigation} from 'swiper';
// components
import Product from './Product';
import ProductSkeleton from "./ProductSkeleton";
import useFetch from "../hooks/useFetch";

const ProductSlider = ({data}) => {
    const rate = useFetch('/rates');

    return (
        <div className="relative">
            <Swiper
                modules={[Pagination, Navigation]}
                loop={false}
                navigation={{
                    nextEl: '.swiper-button-next-custom',
                    prevEl: '.swiper-button-prev-custom',
                }}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    1440: {
                        slidesPerView: 4, 
                        spaceBetween: 50, 
                    },
                }}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                className='productSlider mx-auto px-4 sm:px-6 lg:px-8 xl:px-16 py-12'
            >
                {data?.map((product) => {
                    return (
                        <SwiperSlide key={product.id} className="pb-12 py-4 group"> {/* Added padding bottom for pagination */}
                            {!data ? <ProductSkeleton/> :
                                <Product product={product} data={rate.data}/>
                            }
                        </SwiperSlide>
                    );
                })}
            </Swiper>

            <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 z-10 pointer-events-none">
                <div className="container mx-auto flex justify-between px-4 sm:px-6 lg:px-8 xl:px-16">
                    <div className="swiper-button-prev-custom pointer-events-auto cursor-pointer p-3 bg-white/80 hover:bg-white transition-all duration-300 shadow-lg rounded-full opacity-0 group-hover:opacity-100 -ml-6 xl:-ml-12">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                    </div>

                    <div className="swiper-button-next-custom pointer-events-auto cursor-pointer p-3 bg-white/80 hover:bg-white transition-all duration-300 shadow-lg rounded-full opacity-0 group-hover:opacity-100 -mr-6 xl:-mr-12">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductSlider;
